'use client'

import Script from 'next/script'
import { useTermlyConsent } from './useTermlyConsent'

interface ConsentBasedRedditPixelProps {
  pixelId: string
  debug?: boolean
}

export function ConsentBasedRedditPixel({
  pixelId,
  debug = false
}: ConsentBasedRedditPixelProps) {
  const hasConsent = useTermlyConsent(debug)

  if (!hasConsent) {
    return null
  }

  return (
    <Script
      id="reddit-pixel-script"
      data-testid="reddit-pixel-script"
      data-category="advertising"
      strategy="afterInteractive"
    >
      {`
        !function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);
        rdt('init', ${JSON.stringify(pixelId)});
        rdt('track', 'PageVisit');
      `}
    </Script>
  )
}

export default ConsentBasedRedditPixel
